import { AVAILABLE_LANGUAGES } from '@/constants';
import { SylndrHelpPoint } from '../sylndr-help.types';
import Image from 'next/image';
import { InfoCircleBlue } from 'public/Images';
import Typography from '@/components/shared/typography/typography.component';

export const HelpSectionSteps = ({
    section,
    lang,
}: {
    section: SylndrHelpPoint;
    lang: AVAILABLE_LANGUAGES;
}) => {
    return (
        <div className="p-3 bg-gray-100 rounded-lg">
            <div className="flex justify-between mb-1.5">
                <Typography className="text-gray-800 text-captionSemiBold md:text-body2SemiBold">
                    {section.stepsTitle[lang]}
                </Typography>
                <Typography className="text-primary-700 text-captit-gray-800 md:text-body2SemiBold">
                    {section.cost[lang]}
                </Typography>
            </div>
            <div className="mb-2">
                {section.steps.map((s, idx) => {
                    return (
                        <Typography
                            key={idx}
                            className="text-gray-500 text-caption md:text-body2 mb-1"
                        >
                            {'• '}
                            {s.title[lang]}
                        </Typography>
                    );
                })}
            </div>
            <div className="p-3 flex items-center gap-x-2 bg-blue-100 rounded-lg">
                <div className="flex-shrink-0 max-md:self-start max-md:ar:mt-1">
                    <Image
                        src={InfoCircleBlue}
                        alt="info"
                        width={17}
                        height={16}
                    />
                </div>
                <Typography className="text-gray-800 text-caption2 md:text-caption ar:mt-0.5">
                    {section.info[lang]}
                </Typography>
            </div>
        </div>
    );
};
